import { render, staticRenderFns } from "./supplier_management.vue?vue&type=template&id=2e2bb76e&scoped=true"
import script from "./supplier_management.vue?vue&type=script&lang=js"
export * from "./supplier_management.vue?vue&type=script&lang=js"
import style0 from "./supplier_management.vue?vue&type=style&index=0&id=2e2bb76e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2bb76e",
  null
  
)

export default component.exports